import { Auth0Context, initialContext } from '@auth0/auth0-react';
import { ReactNode } from 'react';

import { auth0SimpleUser } from '@/mocks/data/userData';

const MOCK_ACCESS_TOKEN = 'mock-access-token';

const mockAuth0Value = {
  ...initialContext,
  isLoading: false,
  isAuthenticated: true,
  user: auth0SimpleUser,
  getAccessTokenSilently: (async () => MOCK_ACCESS_TOKEN) as never,
  getIdTokenClaims: async () => undefined,
  loginWithRedirect: async () => {},
  logout: async () => {},
};

/**
 * Replaces Auth0Provider in mock mode (`npm run dev:mock`) so the app boots
 * already logged in as the mocked user, without going through Auth0.
 */
export const MockAuth0Provider = ({ children }: { children: ReactNode }) => (
  <Auth0Context.Provider value={mockAuth0Value}>
    {children}
  </Auth0Context.Provider>
);
